import React from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../contexts/AuthContext';

const PermissionGate = ({
  permission,
  anyOf,
  allOf,
  fallback = null,
  children
}) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } = useAuth();

  let allowed = true;

  if (permission) {
    allowed = hasPermission(permission);
  } else if (Array.isArray(allOf) && allOf.length) {
    allowed = hasAllPermissions(allOf);
  } else if (Array.isArray(anyOf) && anyOf.length) {
    allowed = hasAnyPermission(anyOf);
  }

  if (!allowed) {
    return typeof fallback === 'function' ? fallback() : fallback;
  }

  if (typeof children === 'function') {
    return children({ allowed: true });
  }

  return <>{children}</>;
};

PermissionGate.propTypes = {
  permission: PropTypes.string,
  anyOf: PropTypes.arrayOf(PropTypes.string),
  allOf: PropTypes.arrayOf(PropTypes.string),
  fallback: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

export default PermissionGate;




